(function () {
	'use strict';

	angular.module('widgets.supplychain')
		.controller('posToActionNext12MonthsChart', posToActionNext12MonthsChart);

	function posToActionNext12MonthsChart($rootScope, $scope, $filter, $uibModal, $timeout,
			dashboardFilterInitializationService, leanFilterService, currencyFormatService, poToActionMonthlyService, pageTimingService) {
		var reportConfig = {};
		var reportSettingsName = 'POsToActionNext12Months';

		// Set navigation properties
		$scope.emptyHeader = 'We couldn\'t find any results.';
		$scope.emptySuggestion = '';
		$scope.emptyLinkText = '';

		function init() {
			$scope.isSupplierPortal = (globalConfig.user.role === 'Supplier');
			$scope.tableName = 'PoToActionMonthly';
			$scope.filterService = dashboardFilterInitializationService;
			$scope.leanFilterService = leanFilterService;
			$scope.initialLoad = true;
			$scope.initialReadFromConfig = true;
			$scope.loading = true;
			$scope.visibleMenu = 'top';
			$scope.allSelected = false;
			$scope.noneSelected = false;
			$scope.numberSelected = 0;
			$scope.applied = false;
			$scope.slideshowView = $rootScope.slideshowView;

			updateEventBind($scope, [
				'sideBarUpdate', 'posToAction12MonthFilterChanged',
				'slideshowViewChanged'
			]);

			reportConfig.getChart = function () {
				var canLoad = true;
				for (var key in $scope.filterService.updating) {
					if ($scope.filterService.updating[key]) {
						canLoad = false;
						break;
					}
				}
				if (canLoad) {
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					if (!$scope.slideshowView) {
						dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
					poToActionMonthlyService.getChartData($scope.leanFilterService).then(function (data) {
						$scope.loading = false;
						$scope.initialLoad = false;
						$scope.startDate = data.months[0];
						$scope.currencySymbol = data.targetCurrency;
						if (data === '') {
							$scope.empty = true;
						} else {
							var dataSet = data.data[0];
							var chartData = [];

							for (var i = 1; i <= 12; i++) {
								chartData.push({
									'months': data.months[i - 1],
									'poActionCum': dataSet['month' + i + 'PoActionCum'],
									'poAction': dataSet['month' + i + 'PoAction']
								});
							}
							$scope.chartData = chartData;
							$rootScope.$emit('poToActionMonthlyDataReady');
						}
						$rootScope.title = 'LeanDNA Dashboard - PO to Action Next 12 Months';
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					});
				} else {
					$timeout(function () {
						reportConfig.getChart();
					}, 10);
				}
			};

			reportConfig.getChart();
		}

		init();
	}
})();
